module.exports = __webpack_public_path__ + "img/round_thumbs_up.e56adfbf.png";